/**
 * jQuery plugin to lazy load slick sliders
 * depends on jquery.animateOnScroll.js, slick.js
 * created by bogdan.b@codingheads.com
 * requires IntersectionObserver, jquery.animateOnScroll.js, slick.js
 */

jQuery(function($) {
  $.fn.chLazySlick = function(slickArgs = {}) {
    if (this.length) {
      this.each(function(index) {
        const $this = $(this);
        this.dataset.lazySlick = true;
        this.classList.add('lazy-slick');

        // lazy load slider
        let sliderLoaded = false;
        $this.animateOnScroll({
          options: {
            rootMargin: index < 2 ? '500px 100px' : '1000px 100px', // trigger the animation before the objects are in sight
          },
          callback: () => {
            if (sliderLoaded) return;
            sliderLoaded = true;
            if ('asNavFor' in slickArgs) {
              $(slickArgs.asNavFor).trigger('animateOnScroll');
            }

            $this
              .on('init', () => {
                if ('chMatchHeight' in window) {
                  chMatchHeight($this);
                } else if ('throttle' in window) {
                  window.throttle(window.resize, 100);
                }
              })
              .slick(slickArgs)
              .on('beforeChange', function(e, $slick, currentSlide, nextSlide) {
                // trigger loading the next image earlier
                const nextSlideIndex =
                  nextSlide - 1 + $this.slick('slickGetOption', 'slidesToShow');
                const $next = $slick.$slides.slice(
                  nextSlideIndex,
                  nextSlideIndex +
                    $this.slick('slickGetOption', 'slidesToScroll')
                );
                $next
                  .find(
                    '[data-lazy-interchange], [data-lazy-bg], [data-lazy-img], [data-lazy-iframe], [data-lazy-css]'
                  )
                  .trigger('animateOnScroll');
              });
          },
        });
      });
    }
    return this;
  };
});
